import { WalletTypeEnum } from '@aelf-web-login/wallet-adapter-base';
import { LoginStatusEnum } from '@portkey/types';
import { configureStore, createSlice } from '@reduxjs/toolkit';
var initialState = {
  walletInfo: undefined,
  isLocking: false,
  walletType: WalletTypeEnum.unknown,
  loginError: null,
  loginOnChainStatus: LoginStatusEnum.INIT,
  approvedGuardians: []
};
var aelfWebLoginSlice = createSlice({
  name: 'aelfWebLogin',
  initialState: initialState,
  reducers: {
    setWalletInfo: function setWalletInfo(state, action) {
      state.walletInfo = action.payload;
    },
    clearWalletInfo: function clearWalletInfo(state) {
      state.walletInfo = undefined;
    },
    setLocking: function setLocking(state, action) {
      state.isLocking = action.payload;
    },
    setWalletType: function setWalletType(state, action) {
      state.walletType = action.payload;
    },
    clearWalletType: function clearWalletType(state) {
      state.walletType = WalletTypeEnum.unknown;
    },
    setLoginError: function setLoginError(state, action) {
      state.loginError = action.payload;
    },
    clearLoginError: function clearLoginError(state) {
      state.loginError = null;
    },
    setLoginOnChainStatus: function setLoginOnChainStatus(state, action) {
      state.loginOnChainStatus = action.payload;
    },
    setApprovedGuardians: function setApprovedGuardians(state, action) {
      state.approvedGuardians = action.payload;
    }
  }
});
export var store = configureStore({
  reducer: aelfWebLoginSlice.reducer,
  middleware: function middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['aelfWebLogin/setWalletInfo'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['walletInfo.extraInfo.provider', 'walletInfo.extraInfo.portkeyInfo.walletInfo', 'walletInfo.extraInfo.nightElfInfo', 'loginError.nativeError', 'payload.nativeError'],
        // Ignore these paths in the state
        ignoredPaths: ['walletInfo.extraInfo.provider', 'walletInfo.extraInfo.portkeyInfo.walletInfo', 'walletInfo.extraInfo.nightElfInfo', 'loginError.nativeError', 'payload.nativeError']
      }
    });
  },
  devTools: process.env.NODE_ENV !== 'production'
});
var _aelfWebLoginSlice$ac = aelfWebLoginSlice.actions,
  setWalletInfo = _aelfWebLoginSlice$ac.setWalletInfo,
  clearWalletInfo = _aelfWebLoginSlice$ac.clearWalletInfo,
  setLocking = _aelfWebLoginSlice$ac.setLocking,
  setWalletType = _aelfWebLoginSlice$ac.setWalletType,
  clearWalletType = _aelfWebLoginSlice$ac.clearWalletType,
  setLoginError = _aelfWebLoginSlice$ac.setLoginError,
  clearLoginError = _aelfWebLoginSlice$ac.clearLoginError,
  setLoginOnChainStatus = _aelfWebLoginSlice$ac.setLoginOnChainStatus,
  setApprovedGuardians = _aelfWebLoginSlice$ac.setApprovedGuardians;
export { setWalletInfo, clearWalletInfo, setLocking, setWalletType, clearWalletType, setLoginError, clearLoginError, setLoginOnChainStatus, setApprovedGuardians };
export var dispatch = store.dispatch;